var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvkFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_65017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V45H0V0Z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V30H0V0Z",
    fill: "#0B4EA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V15H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8438 34.7623C17.8126 32.8217 12.0376 28.9592 12.0376 21.3373C12.0376 13.7061 12.4126 10.2373 12.4126 10.2373H31.2845C31.2845 10.2373 31.6501 13.7061 31.6501 21.3373C31.6501 28.9686 25.8751 32.8123 21.8438 34.7623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8438 33.75C18.1406 31.9688 12.8438 28.425 12.8438 21.4313C12.8438 14.4375 13.1813 11.25 13.1813 11.25H30.5062C30.5062 11.25 30.8344 14.4375 30.8344 21.4313C30.8438 28.4344 25.5469 31.9688 21.8438 33.75Z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6312 19.5936C23.6344 19.6123 25.5938 19.6498 27.3281 19.0686C27.3281 19.0686 27.2906 19.6967 27.2906 20.4186C27.2906 21.1404 27.3375 21.7686 27.3375 21.7686C25.7438 21.2342 23.7656 21.2248 22.6312 21.2342V25.0967H21.0563V21.2342C19.9313 21.2248 17.9531 21.2342 16.3594 21.7686C16.3594 21.7686 16.4062 21.1404 16.4062 20.4186C16.4062 19.6873 16.3594 19.0686 16.3594 19.0686C18.0938 19.6498 20.0531 19.6123 21.0469 19.5936V17.1654C20.1375 17.1654 18.825 17.2029 17.3344 17.6998C17.3344 17.6998 17.3812 17.0811 17.3812 16.3498C17.3812 15.6279 17.3344 14.9998 17.3344 14.9998C18.825 15.4967 20.1375 15.5436 21.0469 15.5342C21 13.9967 20.55 12.0654 20.55 12.0654C20.55 12.0654 21.4781 12.1311 21.8438 12.1311C22.2188 12.1311 23.1375 12.0654 23.1375 12.0654C23.1375 12.0654 22.6875 13.9967 22.6406 15.5342C23.55 15.5436 24.8625 15.4967 26.3531 14.9998C26.3531 14.9998 26.3063 15.6279 26.3063 16.3498C26.3063 17.0811 26.3531 17.6998 26.3531 17.6998C25.1517 17.3124 23.8932 17.1317 22.6312 17.1654V19.6029V19.5936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8437 24.6846C19.978 24.6846 18.9843 27.2627 18.9843 27.2627C18.9843 27.2627 18.4218 26.0439 16.903 26.0439C15.8718 26.0439 15.1218 26.9533 14.6343 27.8064C16.5093 30.7783 19.4999 32.6158 21.8437 33.7502C24.1874 32.6252 27.1874 30.7783 29.053 27.8064C28.5655 26.9627 27.8155 26.0439 26.7843 26.0439C25.2655 26.0439 24.703 27.2627 24.703 27.2627C24.703 27.2627 23.7187 24.6846 21.8437 24.6846Z",
    fill: "#0B4EA2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_65017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvkFlag);
export default __webpack_public_path__ + "static/media/svk-flag.7b9c6ff015d78a4da3ec3c1f54c92d27.svg";
export { ForwardRef as ReactComponent };